import { Modal as AntModal } from "antd";
import { Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function BranchInactiveModal({ visible, onClose }) {
  return (
    <AntModal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      maskClosable={false}
      keyboard={false}
      bodyStyle={{
        textAlign: "center",
        padding: "32px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Warning Icon */}
      <WarningAmberIcon sx={{ fontSize: 48, color: "#ff9800", mb: 1 }} />

      {/* Title */}
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Job Posting Disabled
      </Typography>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{
          fontSize: "1rem",
          lineHeight: 1.6,
          marginTop: "16px",
          color: "#555",
        }}
      >
        This branch is inactive. To activate it, please contact our support team
        at{" "}
        <a
          href="mailto:support@jobizo.com"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          support@jobizo.com
        </a>
        .
      </Typography>
    </AntModal>
  );
}
